import {UPDATE_CDC_CARD_START} from "../../types";

export const update_card_category = (payload) => ({
    type: UPDATE_CDC_CARD_START,
    payload,
});
